export const messages = {
  success: "An email with instructions has been sent to the specified email address.",
  error: "The password reset request failed. Please check the email address provided.",
};
